import { StyleSheet } from 'react-native';

import { LAYOUT, THEME } from '../../reactor/common';

const { COLOR, OFFSET, UNIT } = THEME;

export default StyleSheet.create({
  container: {
    backgroundColor: COLOR.WHITE,
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: '100%',
    zIndex: 1,
    padding: OFFSET,
  },

  title: {
    marginTop: UNIT,
    marginBottom: UNIT / 2,
    alignSelf: 'center',
  },

  cards: StyleSheet.flatten([
    LAYOUT.STYLE.ROW,
    {
      alignItems: 'flex-start',
      alignContent: 'flex-start',
      alignSelf: 'center',
      flexWrap: 'wrap',
      height: '100%',
      justifyContent: 'center',
      maxWidth: 1024,
    },
  ]),

  button: {
    position: 'absolute',
    right: 0,
    zIndex: 1,
  },
});
